'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../../node_modules/@material-ui/core/esm/styles/makeStyles.js');
var Backdrop$1 = require('../../../node_modules/@material-ui/core/esm/Backdrop/Backdrop.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles(function (theme) {
  return {
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.palette.white.primary,
      opacity: 0.8
    }
  };
});
var Backdrop = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      restProps = objectWithoutProperties(_ref, ["children"]);

  var _useStyles = useStyles(),
      backdrop = _useStyles.backdrop;

  return React__default["default"].createElement(Backdrop$1["default"], _objectSpread({
    className: backdrop,
    ref: ref
  }, restProps), children);
});

module.exports = Backdrop;
